export const supportedLanguages = ['en', 'de', 'pl'] as const;

export type Language = typeof supportedLanguages[number];

export type FlatFieldTranslations<Name extends string, Value> = {
    [K in Language as `${Name}_${K}`]: Value;
};
